import React, { Fragment } from 'react';
import moment from 'moment';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';


import Typography from '@mui/material/Typography';
import Icon from '@mdi/react';
import { mdiSteering, mdiFlagCheckered, mdiGasStation } from '@mdi/js';
import { renderAddressMapLink } from './reportMapLinks';

const FuelActivityTimeLine = ({ data }) => {

    const capitalizeFirst = str => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    return (
        <Timeline position="alternate">

            {
                data.map((d, i) =>
                    d.type === 'start' ?
                        <Fragment key={i}>
                            <TimelineItem>
                                <TimelineOppositeContent
                                    sx={{ m: 'auto 0' }}
                                    align="right"
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {renderAddressMapLink({
                                        address: d.address,
                                        fallback: '',
                                        lat: d.lat,
                                        lng: d.lng,
                                        source: d,
                                    })}
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot color="primary">
                                        <Icon
                                            path={mdiFlagCheckered}
                                            title="Start"
                                            size={1}
                                            color="White"
                                        />
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <Typography variant="h6" component="span">
                                        Start
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">{moment(d.time).format("Do MMM 'YY hh:mm a")}</Typography>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="success" />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent><b>{`${d.volume} Liters`}</b></TimelineContent>
                            </TimelineItem>
                        </Fragment>

                        : d.type === 'journeyLeg' ?
                            <Fragment key={i}>
                                <TimelineItem>
                                    <TimelineOppositeContent
                                        sx={{ m: 'auto 0' }}
                                        align="right"
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        <Typography variant="body2">{d.consumption.toFixed(1)} Liters</Typography>
                                        <Typography variant="body2">{d.mileage} Km/L</Typography>
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                        <TimelineConnector />
                                        <TimelineDot color="info">
                                            <Icon
                                                path={mdiSteering}
                                                title="Start"
                                                size={1}
                                                color="White"
                                            />
                                        </TimelineDot>
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                                        <Typography variant="h6" component="span">
                                            Drive
                                        </Typography>
                                        <Typography variant="body2">{d.distance.toFixed(1)} Km</Typography>
                                        <Typography variant="body2">{d.totalDuration}</Typography>
                                    </TimelineContent>
                                </TimelineItem>
                            </Fragment>
                            : d.type === 'event' ?
                                <Fragment key={i}>
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <TimelineDot color="error" />
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent><Typography variant="body1"><b>{`${d.startVol} Liters`}</b></Typography></TimelineContent>
                                    </TimelineItem>
                                    <TimelineItem>
                                        <TimelineOppositeContent
                                            sx={{ m: 'auto 0' }}
                                            align="right"
                                            variant="body2"

                                        >
                                            <Typography variant="body2" color="text.secondary">{moment(d.time).format("Do MMM 'YY hh:mm a")}</Typography>
                                            <Typography variant="body1"><b>{d.volume} Liters</b></Typography>

                                        </TimelineOppositeContent>
                                        <TimelineSeparator>
                                            <TimelineConnector />
                                            <TimelineDot color={d.event_type === 'filling' ? "success" : "error"}>
                                                <Icon
                                                    path={mdiGasStation}
                                                    title="Start"
                                                    size={1}
                                                    color="White"
                                                />
                                            </TimelineDot>
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent sx={{ py: '12px', px: 2 }}>
                                            <Typography variant="h6" component="span">
                                                {capitalizeFirst(d.event_type)}
                                            </Typography>
                                            <Typography variant="body2">
                                                {renderAddressMapLink({
                                                    address: d.address,
                                                    fallback: '',
                                                    lat: d.lat,
                                                    lng: d.lng,
                                                    source: d,
                                                })}
                                            </Typography>
                                        </TimelineContent>
                                    </TimelineItem>
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <TimelineDot color={d.event_type === 'filling' ? "success" : "error"} />
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent><Typography variant="body1"><b>{`${d.endVol} Liters`}</b></Typography></TimelineContent>
                                    </TimelineItem>
                                </Fragment>
                                :
                                <Fragment key={i}>
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <TimelineDot color="error" />
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent><Typography variant="body1"><b>{`${d.volume} Liters`}</b></Typography></TimelineContent>
                                    </TimelineItem>
                                    <TimelineItem>
                                        <TimelineOppositeContent
                                            sx={{ m: 'auto 0' }}
                                            align="right"
                                            variant="body2"
                                            color="text.secondary"
                                        >

                                            <Typography variant="body2">
                                                {renderAddressMapLink({
                                                    address: d.address,
                                                    fallback: '',
                                                    lat: d.lat,
                                                    lng: d.lng,
                                                    source: d,
                                                })}
                                            </Typography>
                                        </TimelineOppositeContent>
                                        <TimelineSeparator>
                                            <TimelineConnector />
                                            <TimelineDot color="error">
                                                <Icon
                                                    path={mdiFlagCheckered}
                                                    title="Start"
                                                    size={1}
                                                    color="White"
                                                />
                                            </TimelineDot>
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent sx={{ py: '12px', px: 2 }}>
                                            <Typography variant="body2" color="text.secondary">{moment(d.time).format("Do MMM 'YY hh:mm a")}</Typography>

                                            <Typography variant="h6" component="span">
                                                End
                                            </Typography>
                                        </TimelineContent>
                                    </TimelineItem>

                                </Fragment>


                )
            }

        </Timeline>
    )
}

export default FuelActivityTimeLine;

/*
<Icon
    path={mdiGasStation}
    title="Logout"
    size={1}
    color="Crimson"
/>
*/
